var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgToggleClosedBtnIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_11_1427_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0162332 -0.00519579 0 7.99997 5.74756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 404.496,
    height: 1119.07,
    fill: "url(#paint0_diamond_11_1427)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 404.496,
    height: 1119.07,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_11_1427)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 404.496,
    height: 1119.07,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_11_1427)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 404.496,
    height: 1119.07,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_11_1427)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5306 7.03073L8.5306 12.0307C8.46092 12.1007 8.37813 12.1561 8.28696 12.194C8.1958 12.2318 8.09806 12.2513 7.99935 12.2513C7.90064 12.2513 7.8029 12.2318 7.71173 12.194C7.62057 12.1561 7.53778 12.1007 7.4681 12.0307L2.4681 7.03073C2.3272 6.88984 2.24805 6.69874 2.24805 6.49948C2.24805 6.30023 2.3272 6.10913 2.4681 5.96823C2.60899 5.82734 2.80009 5.74818 2.99935 5.74818C3.19861 5.74818 3.3897 5.82734 3.5306 5.96823L7.99997 10.4376L12.4693 5.96761C12.6102 5.82671 12.8013 5.74756 13.0006 5.74756C13.1999 5.74756 13.391 5.82671 13.5318 5.96761C13.6727 6.10851 13.7519 6.2996 13.7519 6.49886C13.7519 6.69812 13.6727 6.88921 13.5318 7.03011L13.5306 7.03073Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.85098040103912354,\"b\":0.43921568989753723,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.85098040103912354,\"b\":0.43921568989753723,\"a\":1.0},\"position\":0.50},{\"color\":{\"r\":0.65490198135375977,\"g\":0.49411764740943909,\"b\":0.0078431377187371254,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.85098040103912354,\"b\":0.43921568989753723,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.85098040103912354,\"b\":0.43921568989753723,\"a\":1.0},\"position\":0.50},{\"color\":{\"r\":0.65490198135375977,\"g\":0.49411764740943909,\"b\":0.0078431377187371254,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":5.1926878375392052e-16,\"m01\":-10.391571998596191,\"m02\":13.195760726928711,\"m10\":32.466388702392578,\"m11\":4.9709585406287893e-15,\"m12\":-10.485635757446289},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5306 7.03073L8.5306 12.0307C8.46092 12.1007 8.37813 12.1561 8.28696 12.194C8.1958 12.2318 8.09806 12.2513 7.99935 12.2513C7.90064 12.2513 7.8029 12.2318 7.71173 12.194C7.62057 12.1561 7.53778 12.1007 7.4681 12.0307L2.4681 7.03073C2.3272 6.88984 2.24805 6.69874 2.24805 6.49948C2.24805 6.30023 2.3272 6.10913 2.4681 5.96823C2.60899 5.82734 2.80009 5.74818 2.99935 5.74818C3.19861 5.74818 3.3897 5.82734 3.5306 5.96823L7.99997 10.4376L12.4693 5.96761C12.6102 5.82671 12.8013 5.74756 13.0006 5.74756C13.1999 5.74756 13.391 5.82671 13.5318 5.96761C13.6727 6.10851 13.7519 6.2996 13.7519 6.49886C13.7519 6.69812 13.6727 6.88921 13.5318 7.03011L13.5306 7.03073Z",
    fill: "black",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_11_1427_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5306 7.03073L8.5306 12.0307C8.46092 12.1007 8.37813 12.1561 8.28696 12.194C8.1958 12.2318 8.09806 12.2513 7.99935 12.2513C7.90064 12.2513 7.8029 12.2318 7.71173 12.194C7.62057 12.1561 7.53778 12.1007 7.4681 12.0307L2.4681 7.03073C2.3272 6.88984 2.24805 6.69874 2.24805 6.49948C2.24805 6.30023 2.3272 6.10913 2.4681 5.96823C2.60899 5.82734 2.80009 5.74818 2.99935 5.74818C3.19861 5.74818 3.3897 5.82734 3.5306 5.96823L7.99997 10.4376L12.4693 5.96761C12.6102 5.82671 12.8013 5.74756 13.0006 5.74756C13.1999 5.74756 13.391 5.82671 13.5318 5.96761C13.6727 6.10851 13.7519 6.2996 13.7519 6.49886C13.7519 6.69812 13.6727 6.88921 13.5318 7.03011L13.5306 7.03073Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_11_1427",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A77E02"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgToggleClosedBtnIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/toggle_closed_btn_icon.e1f6d514.svg";
export { ForwardRef as ReactComponent };